import { store } from "../store";
import axios from "axios";

// Create an object to store cached responses
const cache = {};

export const courseService = {
  getCourse,
  getVideos,
  getFaq,
  getExternals,
  getAllData,
  getLessonFromServer,
  getGame
};

axios.defaults.xsrfCookieName = process.env.VUE_APP_CSRF_COOKIE_NAME
axios.defaults.xsrfHeaderName = "X-CSRFToken"
axios.defaults.withXSRFToken = true
axios.defaults.withCredentials = true;


const baseApiUrl = process.env.VUE_APP_API_URL;
const courseNum = localStorage.getItem("courseNum");

async function getCourse() {
  const res = await axios.get(`${baseApiUrl}/api/courses/${courseNum}/`, {
    headers: {
      Authorization: ""
    },
    withCredentials: true
  });
  const course = res.data;

  // return course[0].chapters;
  console.log("COURSE DATA LOADED", store.getters.user);

  return course.chapters;
}

async function getVideos() {
  try {
    const res = await axios.get(`${baseApiUrl}/api/courses/${courseNum}/`, {
      headers: {
        Authorization: ""
      },
      withCredentials: true
    });
    const course = res.data;
    course.video_sections.forEach(sec =>
      sec.lessons.sort((a, b) => (a.exorder > b.exorder ? 1 : -1))
    );
    return course.video_sections;
  } catch (err) {
    if (err.response.status == 401) {
      console.log("Issue with login");
    }
  }
}

async function getLessonFromServer(lessonNum) {
  try {
    const res = await axios.get(`${baseApiUrl}/api/lesson/${lessonNum}/`, {
      headers: {
        Authorization: ""
      },
      withCredentials: true
    });
    // const course = res.data;
    return res.data;
  } catch (err) {
    if (err.response.status == 401) {
      console.log("Issue with login");
    }
  }
}

async function getGame(gameId) {
  try {
    const res = await axios.get(`${baseApiUrl}/api/games/${gameId}/`, {
      headers: {
        Authorization: ""
      },
      withCredentials: true
    });
    // const course = res.data;
    return res.data;
  } catch (err) {
    if (err.response.status == 401) {
      console.log("Issue with login");
    }
  }
}

async function getAllData() {
  try {
    const res = await axios.get(`${baseApiUrl}/api/courses/${courseNum}/`, {
      headers: {
        Authorization: ""
      },
      withCredentials: true
    });
    const course = res.data;
    return course;
  } catch (err) {
    if (err.response.status == 401) {
      console.log("Issue with login");
    }
  }
}

async function getFaq() {
  try {
    const res = await axios.get(`${baseApiUrl}/api/courses/${courseNum}/`, {
      headers: {
        Authorization: ""
      },
      withCredentials: true
    });
    const course = res.data;
    return course.faqs;
  } catch (err) {
    if (err.response.status == 401) {
      console.log("Issue with login");
    }
  }
}

async function getExternals(gameType) {
  console.log(gameType);
  try {
    const res = await axios.get(`${baseApiUrl}/api/external_section/`, {
      headers: {
        Authorization: ""
      },
      withCredentials: true
    });
    const results = res.data.results;
    const externals = results
      .map(res => {
        return {
          ...res,
          games: res.games.filter(res => res.game_type == gameType)
        };
      })
      .filter(section => section.games.length);
    console.log(externals);
    return externals;
  } catch (err) {
    if (err.response.status == 401) {
      console.log("Issue with login");
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/courseService.js